import styled from 'styled-components';

export const NoteLabel = styled.label`
  display: block;
  text-align: left;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => (theme ? theme.colors.gray[500] : '#5a5a5a')};
`;

export const NoteField = styled.textarea`
  width: 100%;
  resize: vertical;
  padding: 10px 12px;
  font: inherit;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;

  :focus {
    outline: none;
    border-color: ${({ theme }) => (theme ? theme.colors.primaries.default : '#1d6fb8')};
  }

  :disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;
